export function WrenchIcon({ width = 20 }: { width?: number }) {
  return (
    <svg width={width} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.4015 0.321751C14.4783 -0.370266 12.2436 0.0539342 10.7026 1.595C9.1615 3.13605 8.73728 5.3707 9.42928 7.29395L0 16.7233L3.27673 20L12.706 10.5707C14.6293 11.2627 16.864 10.8385 18.405 9.2974C19.9461 7.75635 20.3703 5.5217 19.6783 3.59845L16.3624 6.91435L14.0006 5.99942L13.0856 3.63762L16.4015 0.321751ZM3.93633 16.0637C4.31238 16.4397 4.31238 17.0494 3.93633 17.4254C3.5603 17.8015 2.95062 17.8015 2.57458 17.4254C2.19853 17.0494 2.19853 16.4397 2.57458 16.0637C2.95062 15.6876 3.5603 15.6876 3.93633 16.0637Z" />
    </svg>
  );
}
